import { motion, AnimatePresence } from 'framer-motion';

const previewContent = {
  notes: (
    <div className="prose prose-indigo max-w-none">
      <h1>Introduction to Machine Learning</h1>
      <p>Machine Learning is a subset of artificial intelligence that focuses on developing systems that can learn from and make decisions based on data.</p>
      <h2>Key Concepts</h2>
      <ul>
        <li>Supervised Learning</li>
        <li>Unsupervised Learning</li>
        <li>Reinforcement Learning</li>
      </ul>
    </div>
  ),
  mindmap: (
    <div className="flex items-center justify-center">
      <img
        src="https://images.unsplash.com/photo-1544383835-bda2bc66a55d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
        alt="Mind Map Preview"
        className="rounded-lg shadow-lg"
      />
    </div>
  ),
  quiz: (
    <div className="space-y-6">
      <div className="rounded-lg border border-gray-200 p-6">
        <h3 className="text-lg font-medium">What is Machine Learning?</h3>
        <div className="mt-4 space-y-2">
          {['A subset of AI', 'A programming language', 'A database system', 'A web framework'].map((option) => (
            <label key={option} className="flex items-center gap-2">
              <input type="radio" name="q1" className="text-indigo-600" />
              <span>{option}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  ),
  glossary: (
    <div className="space-y-4">
      <div className="rounded-lg border border-gray-200 p-4">
        <dt className="font-medium text-indigo-600">Machine Learning</dt>
        <dd className="mt-1">A field of study that gives computers the ability to learn without being explicitly programmed.</dd>
      </div>
    </div>
  ),
  flashcards: (
    <div className="flex justify-center">
      <div className="w-96 rounded-lg border border-gray-200 p-6 shadow-lg">
        <div className="text-center">
          <div className="text-lg font-medium">What is Machine Learning?</div>
          <div className="mt-4 text-gray-600">Click to reveal answer</div>
        </div>
      </div>
    </div>
  ),
};

interface PreviewContentProps {
  activeTab: string;
}

export function PreviewContent({ activeTab }: PreviewContentProps) {
  return (
    <div className="min-h-[400px] rounded-lg border border-gray-200 bg-white p-6">
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.2 }}
        >
          {previewContent[activeTab as keyof typeof previewContent]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}